<!-- DESC：论文状态页面 -->
<template>
    <div class="paperstatus-box">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">Submission Status Page for {{ $route.query.acronym }}</div>
                    <br />
                    <div class="info">
                        You can check the status of all submitted papers here
                    </div>
                    <div class="info">
                        At the same time, you can directly download the specified Excel information
                    </div>
                    <div class="info">
                        And you can also directly download the specified paper file
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <!-- 列表 -->
                <div class="click-tips">
                    <div class="tools-box" style="display: flex;justify-content: space-between;margin-bottom: 10px;">
                        <div class="tools-left">
                            <!-- <el-tag style="cursor: pointer;margin-right: 10px;" @click="createProceedings"
                                type="primary">Create proceedings</el-tag> -->
                        </div>
                        <div class="tools-left">
                            <el-tag style="cursor: pointer;margin-right: 10px;" @click="outExcel"
                                type="primary">Download
                                Excel</el-tag>
                            <el-tag style="cursor: pointer;margin-right: 10px;" @click="outPaper">Download
                                Papers</el-tag>
                        </div>
                    </div>
                </div>
                <div class="paperlist-box">
                    <el-card shadow="always">
                        <el-table :data="conferencePaperList" style="width: 100%" border class="tb-box"
                            ref="multipleTableRef" @selection-change="handleSelectionChange" v-loading="loading"
                            element-loading-text="Loading..." :element-loading-spinner="svg"
                            element-loading-svg-view-box="-10, -10, 50, 50" @sort-change="sortTable">
                            <el-table-column type="selection" width="55" align="center" />
                            <el-table-column label="Submission" header-align="center">
                                <template #default="scope">
                                    <el-text type="primary" class="title-text" size="small">{{ scope.row.autoid
                                        }}.{{ scope.row.authors }}/{{ scope.row.title }}</el-text>
                                </template>
                            </el-table-column>
                            <el-table-column label="Decision" align="center" header-align="center" width="100"
                                :filters="[{ text: 'ACCEPT', value: 'ACCEPT' }, { text: 'REJECT', value: 'REJECT' }, { text: 'UNKNOW', value: 'UNKNOW' }]"
                                :filter-method="filterTag">
                                <template #default="scope">
                                    <el-tooltip class="box-item" effect="dark" content="Click to Change"
                                        placement="bottom">
                                        <el-tag type="danger" class="title-text" v-if="scope.row.isTermination == 1"
                                            style="cursor: pointer;" @click=statusUpdate(scope.row,1)>REJECT</el-tag>
                                        <el-tag type="success" class="title-text"
                                            v-else-if="scope.row.status == 4 && scope.row.isTermination != 1"
                                            style="cursor: pointer;" @click=statusUpdate(scope.row,0)>ACCEPT</el-tag>
                                        <span class="title-text" v-else></span>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column label="UpdateTime" align="center" width="160" sortable="custom"
                                header-align="center">
                                <template #default="scope">
                                    <el-text class="title-text" size="small">{{ scope.row.updatetime }}</el-text>
                                </template>
                            </el-table-column>
                            <el-table-column label="operate" width="180" align="center">
                                <template #header>
                                    <el-input v-model="searchValue" size="small" placeholder="enter search content"
                                        @input="changeSearchValue" :suffix-icon="Search" />
                                </template>
                                <template #default="scope">
                                    <el-button size="small" @click="download(scope.$index, scope.row)" type="danger"
                                        :icon="Document" style="width: 90px;">paper</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <!-- 隐藏层 -->
        <el-dialog v-model="diadownloadZipTip" title="Download Progress" width="30%" center @close="closeRequest">
            <el-progress :percentage="percentage" :color="customColors" />
            <template #footer>
                <span class="dialog-footer">
                    <el-button type="primary" @click="cancelRequest" v-if="percentage != 100">Cancel
                        Download</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import request from "../../network/request"
import { useRouter, useRoute } from "vue-router"
import { View, Document, Refresh, Position, Search, Plus, Message, ArrowLeftBold } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import axios from 'axios'
import { ElLoading } from 'element-plus'

const route = useRoute()
const router = useRouter()

const loading = ref(true)
const percentage = ref(0)
const diadownloadZipTip = ref(false)
const customColors = [
    { color: '#f56c6c', percentage: 20 },
    { color: '#e6a23c', percentage: 40 },
    { color: '#5cb87a', percentage: 60 },
    { color: '#1989fa', percentage: 80 },
    { color: '#6f7ad3', percentage: 100 },
]
const CancelToken = axios.CancelToken;
let source = CancelToken.source();

// 排序规则
const sortRule = ref("autoid asc")
// 搜索值
const searchValue = ref("")
// 会议投稿论文
const conferencePaperList = ref([])
// 选中的论文
const multipleTableRef = ref()
const multipleSelection = ref([])
const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>`


// 表格选择列表修改
const handleSelectionChange = (val) => {
    multipleSelection.value = val
}

// 获取会议投稿论文列表
async function getConferencePaperList() {
    request.get(`/conference/paperlist?pagenum=1&pagesize=99999&cid=${route.query.cid}&sortRule=${sortRule.value}&keyword=${searchValue.value}`).then((res) => {
        conferencePaperList.value = []
        let datalist = res.data.list;
        datalist.forEach((item) => {
            let authornamelist = []
            item.authorList.forEach((author) => {
                authornamelist.push(author.firstname + " " + author.lastname)
            })
            let authornames = authornamelist.join(",")
            let title = item.title
            conferencePaperList.value.push({ id: item.id, pid: item.pid, authors: authornames, title: title, status: item.status, paperfile: item.paperfile, isTermination: item.isTermination, updatetime: item.updatetime, emailaddre: item.emailaddre, authorList: item.authorList, autoid: item.autoid })
            loading.value = false
        })   
    })
}

// 搜索值改变，修改后端
const changeSearchValue = (payload) => {
    setTimeout(()=>{
        getConferencePaperList()
    },500)
}

//下载PDF
const download = (index, payload) => {
    let acronym = route.query.acronym.split(" ").join("_")
    let autoid = payload.autoid
    saveAs(payload.paperfile, `${acronym}_paper_${autoid}.pdf`)
}

// 筛选表格
const filterTag = (value, row) => {
    multipleTableRef.value.clearSelection()
    // 筛选录用
    if (value == "ACCEPT") {
        return row.status == 4 && row.isTermination != 1
    }
    // 筛选拒稿
    else if (value == "REJECT") {
        return row.isTermination == 1
    }
    else {
        return row.status <= 3 && row.isTermination != 1
    }
}

// OutFile（点击导出按钮触发事件,进行论文集导出）
const outPaper = () => {
    let pidlist = []
    multipleSelection.value.forEach((item) => {
        if (!(item.pid in pidlist)) {
            pidlist.push(item.pid)
        }
    })
    if (pidlist.length == 0) {
        ElMessage({
            message: `you need to select a paper`,
            type: 'warning',
        })
        return
    }
    percentage.value = 0
    source = CancelToken.source()
    diadownloadZipTip.value = true
    request.post(`/paper/download`, { cid: route.query.cid, pidlist: pidlist }, {
        responseType: 'blob', "Cache-Control": "no-cache",
        onDownloadProgress: (e) => {
            percentage.value = parseFloat((e.progress * 100).toFixed(1));
        },
        cancelToken: source.token,
        timeout: 1000 * 60 * 120
    }).then((res) => {
        let blob = new Blob([res], { type: 'type: "application/zip' })
        let objectUrl = URL.createObjectURL(blob) // 创建URL
        const link = document.createElement('a')
        link.href = objectUrl
        // 定义文件名
        link.download = `${route.query.acronym}_submissions.zip`
        // 下载文件
        link.click()
        ElMessage({
            message: `successfully exported the collection of papers`,
            type: 'success',
        })
        // 释放内存
        URL.revokeObjectURL(objectUrl);
    }).catch((error) => {

    });
}

// 导出Excel文件
const outExcel = () => {
    let pidlist = []
    multipleSelection.value.forEach((item) => {
        if (!(item.pid in pidlist)) {
            pidlist.push(item.pid)
        }
    })
    if (pidlist.length == 0) {
        ElMessage({
            message: `you need to select a paper`,
            type: 'warning',
        })
        return
    }
    const loading = ElLoading.service({
        // 加载进度条
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    })
    request.post(`/paper/outexcel`, { cid: route.query.cid, pidlist: pidlist }, { responseType: 'blob' }).then((res) => {
        let blob = new Blob([res], { type: "application/octet-stream" })
        let objectUrl = URL.createObjectURL(blob) // 创建URL
        const link = document.createElement('a')
        link.href = objectUrl
        // 定义文件名
        link.download = `${route.query.acronym}_submissions.xlsx`
        // 下载文件
        link.click()
        ElMessage({
            message: `excel export successful`,
            type: 'success',
        })
        // 释放内存
        URL.revokeObjectURL(objectUrl);
        loading.close()
    })
}

// 取消请求的函数
const closeRequest = () => {
    diadownloadZipTip.value = false
    source.cancel('user cancel');
}

// 取消请求的函数
const cancelRequest = () => {
    ElMessage({
        message: `Cancel Download`,
        type: 'warning',
    })
    diadownloadZipTip.value = false
    source.cancel('user cancel');
}

// 创建出版编辑
const createProceedings = () => {
    router.push(`/common/proceedingsadd?cid=${route.query.cid}&acronym=${route.query.acronym}`)
}

// 获取排序列和排序规则，交由后端负责排序
const sortTable = (payload) => {
    if (payload.column.order == "ascending") {
        sortRule.value = payload.column.label.toLowerCase() + " " + payload.column.order.substring(0, 3)
        getConferencePaperList()
    }
    else if (payload.column.order == "descending") {
        sortRule.value = payload.column.label.toLowerCase() + " " + payload.column.order.substring(0, 4)
        getConferencePaperList()
    }
    else {
        sortRule.value = "autoid desc"
        getConferencePaperList()
    }

}

// 更新论文信息
const statusUpdate = (item, isaccept) => {
    request.patch(`/paper/status/${item.pid}`, { isaccept: isaccept }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: `Paper status update successful`,
                type: 'success',
            })
            if (isaccept == 1) {
                item.status = 4
                item.isTermination = 0
            } else {
                item.isTermination = 1
            }
        }
    })
}

onMounted(() => {
    // 获取会议投稿论文列表
    getConferencePaperList()
})

</script>

<style lang="scss">
.paperstatus-box {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }

        .tools-box {
            display: flex;
            justify-content: space-between;
        }
    }

}
</style>